(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lnk-announcement-marquee')) {
    customElements.define('lnk-announcement-marquee', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.lnk-announcement-track');
        this.group = this.querySelector('.lnk-announcement-group');
        this.group.querySelectorAll('[aria-hidden]').forEach(el => el.removeAttribute('aria-hidden'));
        this.update = () => {
          if (!this.isConnected) return;
          const width = this.group.getBoundingClientRect().width;
          const scroll = width > this.clientWidth + 1;
          this.toggleAttribute('data-scrolling', scroll);
          if (scroll && !this.copy) {
            this.copy = this.group.cloneNode(true);
            this.copy.setAttribute('aria-hidden', 'true');
            this.copy.setAttribute('inert', '');
            this.copy.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
            this.track.append(this.copy);
          } else if (!scroll && this.copy) {
            this.copy.remove(); this.copy = null;
          }
          this.style.setProperty('--marquee-duration', `${Math.max(12, width / 28)}s`);
        };
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this);
        this.observer.observe(this.group);
        this.update();
        document.fonts.ready.then(this.update);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
